import { useEffect, useRef } from "react";

/**
 * useFormSecurity — gathers anti-bot signals for public form submissions.
 *
 * Returns:
 *   - getSignals(): object with { loaded_at, hb } to merge into the form payload.
 *
 * Behavior counts are pure integers (no PII, no content). Server-side scoring
 * uses these alongside the honeypot + CMS-configured thresholds.
 */
export function useFormSecurity() {
  const loadedAtRef = useRef(Date.now() / 1000);
  const counts = useRef({ k: 0, c: 0, f: 0, p: 0 });

  useEffect(() => {
    loadedAtRef.current = Date.now() / 1000;
    const onKey = () => counts.current.k++;
    const onClick = () => counts.current.c++;
    const onFocus = () => counts.current.f++;
    const onPaste = () => counts.current.p++;
    window.addEventListener("keydown", onKey, { passive: true });
    window.addEventListener("click", onClick, { passive: true });
    window.addEventListener("focusin", onFocus, { passive: true });
    window.addEventListener("paste", onPaste, { passive: true });
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("click", onClick);
      window.removeEventListener("focusin", onFocus);
      window.removeEventListener("paste", onPaste);
    };
  }, []);

  const getSignals = () => ({
    loaded_at: loadedAtRef.current,
    hb: JSON.stringify(counts.current),
  });

  return { getSignals };
}
